var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompletedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#00ACB9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3969_10401)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.1963 30.5612C33.2137 28.1877 32.2755 26.3107 30.4041 24.9851C28.9587 23.9645 27.2047 23.4321 25.5082 22.9206C21.974 21.8492 20.9488 21.2848 20.9488 19.5948C20.9488 17.7122 23.3954 17.0424 25.4898 17.0424C27.015 17.0424 28.7699 17.5166 29.8597 18.2195L32.0203 14.8733C30.596 13.95 28.6466 13.3201 26.7217 13.1247V10H22.7361V13.3438C19.1932 14.1231 16.9614 16.4387 16.9614 19.5948C16.9614 21.8051 17.8798 23.558 19.6861 24.7943C21.0599 25.7382 22.7354 26.245 24.3538 26.7357C27.8203 27.7835 29.228 28.422 29.212 30.5365L29.2119 30.5521C29.2119 32.3268 26.86 32.9577 24.8451 32.9577C22.9417 32.9577 20.8719 32.1235 19.6987 30.8833L16.8032 33.6221C18.289 35.1936 20.4478 36.3046 22.736 36.7401V40.0001H26.7217V36.8103C30.6585 36.2468 33.1924 33.8766 33.1963 30.5612Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3969_10401"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompletedIcon);
export default __webpack_public_path__ + "static/media/completedIcon.9345ea5d19763572a7140182b892bda7.svg";
export { ForwardRef as ReactComponent };